import React, { useState } from "react";
import { useAuth } from "../../../Context/AuthContext";

import Select from "../../../Components/Custom/Forms/Select";
import Layout from "../../../Components/Layout";
import { Box } from "@mui/material";
import Destinos from "./Components/Destinos";
import Motivos from "./Components/Motivos";
import Especies from "./Components/Especies";
const Cruds = () => {
  const { authState } = useAuth();

  const [tab, setTab] = useState("destinos");

  const options = [
    { value: "destinos", label: "Destinos" },
    { value: "motivos", label: "Motivos" },
    { value: "especies", label: "Especies" },
  ];
  return (
    <Box 
      sx={{
        mt: '96px', // Espacio para el Navbar
        minHeight: 'calc(100vh - 96px)',
        width: '100%',
        display: 'flex',       // Flex para centrar el contenido principal
        justifyContent: 'center'
      }}
    >
      <Box sx={{ width: { xs: '95%', md: '95%' }, maxWidth: '1200px' }}>
        
        <h1 className="my-4 font-titles text-2xl">
          Selecciona en que catálogo quieres trabajar:
        </h1>

        {/* Header con Flexbox */}
        <div className="flex justify-between items-center w-full mb-4">
          <h1 className="text-2xl font-primary">
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </h1>
          <Select
            value={tab}
            options={options}
            onChange={(e) => setTab(e.target.value)}
            // Asegúrate que el Select no sea enorme
            className="min-w-[200px]" 
          />
        </div>

        {/* Área de la Tabla */}
        <Box sx={{ width: '100%' }}>
          {tab === "destinos" && <Destinos authState={authState} />}
          {tab === "motivos" && <Motivos authState={authState}/>}
          {tab === "especies" && <Especies authState={authState} />}
        </Box>

      </Box>
    </Box>
  );
};

export default Cruds;
